(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog-tabs"]) return;
  try {
    
  document.querySelectorAll('[data-ctab-tabs]').forEach(function(tabsWrap){
    var wrap = tabsWrap.closest('.ctab-wrap');
    if (!wrap) return;
    var tabs = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-ctab-tab]'));
    var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-ctab-panel]'));

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var target = tab.getAttribute('data-ctab-target');
        tabs.forEach(function(t){ t.classList.toggle('is-active', t === tab); });
        panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-ctab-panel') === target); });
      });
    });

    panels.forEach(function(panel){
      var rail = panel.querySelector('[data-ctab-rail]');
      var prevBtn = panel.querySelector('[data-ctab-prev]');
      var nextBtn = panel.querySelector('[data-ctab-next]');
      if (!rail) return;
      function step(dir){
        var card = rail.querySelector('.ctab-card');
        var w = card ? card.getBoundingClientRect().width + 24 : 300;
        rail.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function(){ step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function(){ step(1); });

      var isDown = false, startX = 0, startScroll = 0, moved = false;
      function pointerX(e){ return (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX; }
      function dragStart(e){ isDown = true; moved = false; startX = pointerX(e); startScroll = rail.scrollLeft; }
      function dragMove(e){ if(!isDown) return; var x = pointerX(e); var delta = startX - x; if (Math.abs(delta) > 4) moved = true; rail.scrollLeft = startScroll + delta; }
      function dragEnd(){ isDown = false; }
      rail.addEventListener('touchstart', dragStart, { passive: true });
      rail.addEventListener('touchmove', dragMove, { passive: true });
      rail.addEventListener('touchend', dragEnd);
      rail.addEventListener('mousedown', dragStart);
      window.addEventListener('mousemove', dragMove);
      window.addEventListener('mouseup', dragEnd);
      rail.querySelectorAll('.ctab-card').forEach(function(card){
        card.addEventListener('click', function(e){ if (moved) e.preventDefault(); });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-cards"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cc-rail]').forEach(function (rail) {
    var carousel = rail.closest('.cc-carousel');
    if (!carousel) return;
    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-cc-card]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-cc-dot]'));
    var prevBtn = carousel.querySelector('[data-cc-prev]');
    var nextBtn = carousel.querySelector('[data-cc-next]');

    function setActive(i) {
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }

    function scrollToCard(i) {
      var card = cards[i];
      if (!card) return;
      rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { scrollToCard(idx); });
    });

    function step(dir) {
      var w = cards[0] ? cards[0].getBoundingClientRect().width + 28 : 300;
      rail.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    var ticking = false;
    function updateActiveFromScroll() {
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      var idx;
      if (maxScroll <= 0) {
        idx = 0;
      } else if (rail.scrollLeft >= maxScroll - 1) {
        idx = cards.length - 1;
      } else {
        var fraction = rail.scrollLeft / maxScroll;
        idx = Math.round(fraction * (cards.length - 1));
      }
      setActive(idx);
    }
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateActiveFromScroll();
        ticking = false;
      });
    });

    setActive(0);

    /* Manual drag support (mouse + touch) as a fallback for environments
       where native overflow-x panning is blocked by ancestor CSS */
    var isDown = false, startX = 0, startScroll = 0, moved = false;

    function pointerX(e) {
      return (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
    }
    function dragStart(e) {
      isDown = true; moved = false;
      startX = pointerX(e);
      startScroll = rail.scrollLeft;
    }
    function dragMove(e) {
      if (!isDown) return;
      var x = pointerX(e);
      var delta = startX - x;
      if (Math.abs(delta) > 4) moved = true;
      rail.scrollLeft = startScroll + delta;
    }
    function dragEnd() { isDown = false; }

    rail.addEventListener('touchstart', dragStart, { passive: true });
    rail.addEventListener('touchmove', dragMove, { passive: true });
    rail.addEventListener('touchend', dragEnd);
    rail.addEventListener('mousedown', dragStart);
    window.addEventListener('mousemove', dragMove);
    window.addEventListener('mouseup', dragEnd);

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) { if (moved) e.preventDefault(); });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
